import "../styles/Treks.css";
import { useState, useEffect } from "react";
import TrekForm from './TrekForm.js'

const KagbhusandiTrek = () => {
  const images = [
    "/images/Kagbhusandi.jpg",
    "/images/Kagbhusandi1.jpg",
    "/images/Kagbhusandi2.jpg",
    "/images/Kagbhusandi3.jpg",
    "/images/Kagbhusandi4.jpg",
    "/images/Kagbhusandi5.jpg",
    "/images/Kagbhusandi6.jpg",
    "/images/Kagbhusandi8.jpg"
  ];

  const [confirm, setConfirm] = useState(false)

  useEffect(() => {
    window.scrollTo({top : 0, behavior : "smooth"})  
  }, [])
  

  return (
    <div className="trek-container">
      <header className="trek-header">
        <img src="/images/Kagbhusandi7.jpg" alt="Kagbhusandi Tal" className="trek-banner"/>
        <h1 className="trek-title">Kagbhusandi Tal Trek</h1>
      </header>

      <main className="trek-main">
        <section className="trek-section">
          <h2>Trek Overview</h2>
          <p>
            Region: Garhwal, Uttarakhand<br/>
            Altitude: 5,200 meters (17,060 feet) above sea level<br/>
            Duration: 6 to 7 days<br/>
            Distance: Approximately 60 km<br/>
            Difficulty: Moderate to Challenging<br/>
            Starting Point: pulna village (2,400 meters),<br/>
            Ending Point:   Pulna village<br/>
            Cost: <strong>INR 22,999 per person</strong><br/>
            Best Season: June to October
          </p>
        </section>
        <div className="btn-container">
            <button className="butn" onClick={()=>setConfirm(true)}>Book Now</button>
        </div>


        <section className="trek-gallery">
          {images.map((img, i) => (
            <img key={i} src={img} alt="Kagbhusandi View" className="gallery-img"/>
          ))}
        </section>

        {[
          {
            title: "Day-wise Itinerary",
            content: [
              "Day 1 : Pulna – Trek to Bhyundar Village - 2500m",
              "Day 2 : Trek to Semartoli Kharak - 3300m",
              "Day 3 : Trek to Raj Kharak – 4000m",
              "Day 4 : Trek to Kagbhusandi Tal - 5200m",
              "Day 5 : Trek back to Semartoli",
              "Day 6 : Trek back from Semartoli to Bhyundar",
              "Day 7 : Trek back from Bhyundar to Pulna"
            ],
          },
          {
            title: "Preparation for Trek",
            content: [
              "Physical fitness: Good physical condition is essential for this challenging trek.",
              "Permits: Obtain necessary permits from the Uttarakhand government.",
              "Guides and porters: Hire experienced guides and porters for assistance.",
              "Camping gear: Bring necessary camping equipment and supplies.",
            ],
          },
          {
            title: "Highlights",
            content: [
              "High-altitude lake: Kagbhusandi Tal is a stunning high-altitude lake surrounded by majestic Himalayan peaks.",
              "Scenic views: Breathtaking views of hathi and ghori peaks.",
              "Wildlife: Spot rare Himalayan wildlife like the Himalayan monal, snow leopard, and blue sheep.",
              "Cultural experiences: Interact with local communities and experience their unique culture."
            ],
          },
          {
            title: "What to Carry",
            content: [
              "Trekking shoes, warm clothes, rain gear",
              "Sunglasses, gloves, daypack",
              "Water bottles, torch, power bank",
              "Personal first aid kit"
            ],
          },
          {
            title: "Tips from Guide",
            content: [
              "Acclimatize well and hydrate",
              "Pack light but smart",
              "No mobile network after Day 1",
              "Respect local customs & nature"
            ],
          }
        ].map((section, i) => (
          <section className="trek-section" key={i}>
            <h2>{section.title}</h2>
            <ul>
              {section.content.map((line, j) => (
                <li key={j}>{line}</li>
              ))}
            </ul>
          </section>
        ))}
        <div className="btn-container">
            <button className="butn" onClick={()=>setConfirm(true)}>Book Now</button>
        </div>
      </main>

      <footer className="trek-footer">
            <p>Note : For any queries regarding the trek you can contact</p>
            <p>📞 +91 94589 27294 || 📞 +91 82734 83585</p>
        © {new Date().getFullYear()} Kagbhusandi Trek Experience
        <h3>Regards</h3> <strong>HOTEL SHYAM PALACE GHANGRIA</strong>
      </footer>
      {confirm && <TrekForm title="KAGBHUSANDI TAL" onClose={()=>setConfirm(false)}/>}
    </div>
  );
};

export default KagbhusandiTrek;